import ViolationsReports from '../../pages/Reports/Violations/ViolationsReports';
import FinanceReports from '../../pages/Reports/Finance/FinanceReports';
import PayrollReport from '../../pages/Reports/Payroll';

export const REPORTS_CONFIG = [
  { label: 'Violations', component: ViolationsReports },
  { label: 'Finance', component: FinanceReports },
  { label: 'Adjustments', component: null }, // we will add this when it's available
  { label: 'Shift Staffing', component: null }, // we will add this when it's available
  { label: 'Payroll', component: PayrollReport },
];

export const TIME_RANGES_REVENUE_REPORT = {
  WEEK: '1W',
  THREE_MONTHS: '3M',
  YEAR: '1Y',
};
